import React from 'react';
import { Iframe } from 'telia-front-react';
import SsoDropdownContent from './util/SsoModule';
const CHOOSE_CLIENT = 'header.dealer.choose-client';
const LOG_IN = 'header.log-in';
export const headerSSO = (rootStore) => {
    const { translate, translations } = rootStore.translationsStore;
    const { skipSsoModule } = rootStore.environmentStore;
    const { handleClick, loginUrl, ssoLinkUrl } = rootStore.logInStore;
    const { authData } = rootStore.ssoStore;
    const { isLoggedIn, isDealer, displayName, customerType } = authData;
    if (!translations) {
        return undefined;
    }
    let label;
    let icon = '#login';
    if (isDealer) {
        label = displayName || translate(CHOOSE_CLIENT);
    }
    else if (isLoggedIn) {
        label = displayName || '';
        icon = customerType === 'B2B' ? '#business-services' : '#contact';
    }
    else {
        label = translate(LOG_IN);
    }
    return {
        id: 'sso',
        icon,
        label,
        url: ssoLinkUrl,
        showArrow: isLoggedIn,
        isTextColor: isLoggedIn,
        onClick: handleClick,
        labelClassName: 'nls_protected',
        location: 'top',
        dropdownPadding: skipSsoModule ? 'none' : isLoggedIn ? 'small' : 'medium',
        dropdownContent: skipSsoModule ? React.createElement(Iframe, { url: loginUrl, title: 'Telia SSO' }) : React.createElement(SsoDropdownContent, { url: loginUrl, rootStore: rootStore }),
        dropdownSize: isLoggedIn ? 'small' : 'large',
        dropdownLabelledBy: isLoggedIn ? 'mandates-title' : 'choose-log-in',
        showOverlay: !isLoggedIn
    };
};
export default headerSSO;
//# sourceMappingURL=HeaderSSO.js.map